import { gql } from '@apollo/client';

export const datadogConfigQuery = gql`
  query DatadogConfigQuery($serviceId: ID!) {
    service(id: $serviceId) {
      id
      title
      datadogMetricsConfig {
        apiKey
        apiRegion
        enabled
        legacyMetricNames
      }
      roles {
        canQueryIntegrations
        canManageIntegrations
      }
      account {
        id
        roles {
          canSetConstrainedPlan
        }
      }
    }
  }
`;

export const updateDatadogApiKeyAndRegionMutation = gql`
  mutation UpdateDatadogApiKeyAndRegionMutation(
    $serviceId: ID!
    $apiKey: String!
    $apiRegion: DatadogApiRegion!
  ) {
    service(id: $serviceId) {
      updateDatadogMetricsConfig(
        apiKey: $apiKey
        apiRegion: $apiRegion
        enabled: true
      ) {
        apiKey
        apiRegion
        enabled
      }
    }
  }
`;

export const updateDatadogEnabledMutation = gql`
  mutation UpdateDatadogEnabledMutation($serviceId: ID!, $enabled: Boolean!) {
    service(id: $serviceId) {
      updateDatadogMetricsConfig(enabled: $enabled) {
        enabled
      }
    }
  }
`;

export const disableDatadogForwardingLegacyMetricNamesMutation = gql`
  mutation DisableDatadogForwardingLegacyMetricNames($serviceId: ID!) {
    service(id: $serviceId) {
      disableDatadogForwardingLegacyMetricNames {
        id
        datadogMetricsConfig {
          legacyMetricNames
        }
      }
    }
  }
`;
